var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uesrLicenseStyles"},[_c('h1',[_vm._v("用户注册及使用协同宝App隐私协议")]),_c('uesrLicenseVue',{staticClass:"content"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }